module.exports = __webpack_public_path__ + "static/media/styledmenu-close.319d0222.svg";